import { postCoreDataSecurityActionTemplateByUrlSlice } from './post';

export const { requestPostCoreDataSecurityActionTemplateByUrl, resetPostCoreDataSecurityActionTemplateByUrl } =
    postCoreDataSecurityActionTemplateByUrlSlice.asyncActionCreators;
